<!-- Created by Arga Ghulam Ahmad - arga@jojonomic.com -->
<template>
  <div
    id="wrapper"
    :class="is_sidebar_minimized ? 'toggled-expand-true' : 'toggled-expand-false'"
    class="toggled">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- Preload -->
    <transition name="fade-slow">
      <j-preload v-if="showPreload" />
    </transition>

    <!-- header border -->
    <j-header v-if="showContent" />

    <!-- Navbar -->
    <j-navbar />

    <!-- sidebar -->
    <j-dual-sidebar-setting
      v-if="showContent"
      :logo="logo"
      :is-sidebar-open="sidebar"
      :products-items="productsDetails"
      :group-products="clonedGroupApps"
      :responsive-logo="responsiveLogo"
      :menus-ui="menusUiSetting"
      :menus-database="menusDatabaseSetting"
      :menus-logic="menusLogicSetting"
      :menus-other="menusOtherSetting"
      @toggle-sidebar="toggleSidebar"/>

    <div
      v-if="sidebar && showContent"
      class="background-blur show"
      @click="sidebar=false"/>

    <!-- Page Content -->
    <div
      v-if="showContent"
      class="display-block h-100">

      <!-- main content -->
      <div class="p__t--52 h-100">
        <transition name="fadeout">
          <router-view/>
        </transition>
      </div>

    </div>

    <!-- notification screen -->
    <j-loading-screen
      v-if="showContent"
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      v-if="showContent"
      ref="infoScreen"
      :message="info_message"/>
    <j-problem-screen
      v-if="showContent"
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <j-success-screen
      v-if="showContent"
      ref="successScreen"
      :message="success_message"/>
    <j-toast
      ref="toastScreen"/>

  </div>
</template>

<script>
/* eslint-disable global-require,import/no-duplicates,vue/name-property-casing, no-unused-vars */
import { mapState } from 'vuex';
import { jPrivCompanySettings } from '@/privilage/company-settings/jPrivCompanySettings';
import { jPrivPackages } from '@/privilage/packages/jPrivPackages';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';
import jMixSidebar from '@jojocoders/jojonomic-ui/src/Mixins/jMixSidebar';
import jPreload from '@/components/jPreload';
import jDualSidebarSetting from '@/components/sidebar/jDualSidebarSetting';
import jNavbar from '@/components/header/jNavbar';
import jToast from '@/components/toast/jToast';
import Vue from 'vue';

export default {
  name: 'jSettingWrapper',
  components: {
    jPreload,
    jDualSidebarSetting,
    jNavbar,
    jToast,
  },
  mixins: [
    jPrivCompanySettings,
    jPrivPackages,
    jPrivRoles,
    jMixNotificationScreen,
    jMixSidebar,
  ],
  data() {
    return {
      showPreload: true,
      showContent: false,
      arrayOfIcon: [],
      user: {
        submenu: {
          menus: [
            {
              id: 1,
              text: 'Logout',
              href: '/logout',
            },
          ],
        },
      },
      iconLauncher: null,
      sidebar: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    clonedGroupApps() {
      const clonedArray = Array.from(Object.create(this.groupProductsDetails));
      clonedArray.forEach((group) => {
        // eslint-disable-next-line
        group.apps = group.applications
      });
      return clonedArray;
    },
    menusUiSetting() {
      const JOJOPRO_URL = process.env.JOJOPRO_URL ? process.env.JOJOPRO_URL : '';
      const url = window.location.href;
      let isInApp = true;

      if (url.includes('pro/setting')) {
        isInApp = url.includes('pro/setting/app');
      }

      return [
        {
          parent: {
            name: 'Application Manager',
            href: isInApp ? '/setting/application' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/setting/application`,
            icon: 'application',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Experience Manager',
            href: isInApp ? '/experience-manager' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/experience-manager`,
            icon: 'experience-manager',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Home Screen Manager',
            href: isInApp ? '/widget' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/widget`,
            icon: 'home-screen',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Analytic Dashboard',
            href: isInApp ? '/canvas' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/canvas`,
            icon: 'analytic',
            isShow: true,
          },
        },
      ];
    },
    menusDatabaseSetting() {
      const JOJOPRO_URL = process.env.JOJOPRO_URL ? process.env.JOJOPRO_URL : '';
      const url = window.location.href;

      let isInApp = true;

      if (url.includes('pro/setting')) {
        isInApp = url.includes('pro/setting/app');
      }

      return [
        {
          parent: {
            name: 'Data Manager',
            href: isInApp ? '/form-data' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/form-data`,
            icon: 'data-manager',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Data Connectivity',
            href: isInApp ? '/data-connectivity' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/data-connectivity`,
            icon: 'data-connectivity',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Third Party Connection',
            href: isInApp ? '/third-party-connection' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/third-party-connection`,
            icon: 'third-party-connection',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Big Data Engine',
            href: isInApp ? '/joana' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/joana`,
            icon: 'joana',
            isShow: process.env.BIG_DATA_ENGINE_MENU === 'true',
          },
        },
      ];
    },
    menusLogicSetting() {
      const JOJOPRO_URL = process.env.JOJOPRO_URL ? process.env.JOJOPRO_URL : '';
      const url = window.location.href;

      let isInApp = true;
      let isInPro = true;

      if (url.includes('pro/setting')) {
        isInApp = url.includes('pro/setting/app');
        isInPro = url.includes('pro/setting/pro');
      }

      return [
        {
          parent: {
            name: 'Visual Programming',
            // href: isInApp ? '/automation' : null,
            // hrefout: `${JOJOPRO_URL}pro/setting/app#/automation`,
            href: isInApp ? '/visual-programming' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/visual-programming`,
            icon: 'visual-programming',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Workflow Manager',
            href: isInPro ? '/flows' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/pro#/flows`,
            icon: 'workflow',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Artificial Intelligence',
            href: isInApp ? '/ai' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/ai`,
            icon: 'ai',
            isShow: false,
          },
        },
      ];
    },
    menusOtherSetting() {
      const JOJOPRO_URL = process.env.JOJOPRO_URL ? process.env.JOJOPRO_URL : '';
      const url = window.location.href;

      let isInEmployee = true;
      let isInPro = true;
      // let isInForm = true;
      let isInApp = true;

      if (url.includes('pro/setting')) {
        isInEmployee = url.includes('pro/setting/employee');
        isInPro = url.includes('pro/setting/pro');
        // isInForm = url.includes('pro/setting/form');
        isInApp = url.includes('pro/setting/app');
      }

      return [
        {
          parent: {
            name: 'Administrator',
            href: isInApp ? '/administrator' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/user`,
            icon: 'administrator',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'Access Management',
            href: isInApp ? '/access-application' : null,
            hrefout: `${JOJOPRO_URL}pro/setting/app#/access-application`,
            icon: 'access-management',
            isShow: true,
          },
        },
        // {
        //   parent: {
        //     name: 'User',
        //     href: isInEmployee ? '/administrator' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/app#/user`,
        //     icon: 'user',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Position',
        //     href: isInApp ? '/administrator/position' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/app#/position`,
        //     icon: 'position',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Unit',
        //     href: isInPro ? '/administrator/unit' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/pro#/unit`,
        //     icon: 'unit',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Company',
        //     href: isInPro ? '/administrator/company/profile' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/pro#/company/profile`,
        //     icon: 'company',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Features',
        //     href: isInApp ? '/administrator/company/feature' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/app#/company/feature`,
        //     icon: 'features',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Layer',
        //     href: isInPro ? '/administrator/layer' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/pro#/layer`,
        //     icon: 'layer',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Location',
        //     href: isInPro ? '/administrator/location' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/pro#/location`,
        //     icon: 'location',
        //     isShow: true,
        //   },
        // },
        // {
        //   parent: {
        //     name: 'Form',
        //     href: isInForm ? '/config/tab/form' : null,
        //     hrefout: `${JOJOPRO_URL}pro/setting/form#/config/tab/form`,
        //     icon: 'form',
        //     isShow: true,
        //   },
        // },
      ];
    },
  },
  watch: {
    $route() {
      this.sidebar = false;
    },
  },
  mounted() {
    setInterval(() => {
      if (!Vue.ls.get('Token')) {
        this.$router.replace('/logout');
        window.location = '/';
      }

      const tokenData = localStorage.getItem('Token');
      if (tokenData) {
        try {
          const tokenObj = JSON.parse(tokenData);
          if (tokenObj && tokenObj.expire) {
            const expire = tokenObj.expire;
            const now = Date.now();
            if (expire - 300000 < now) {
              this.$store.dispatch('jStoreLogin/refreshTokenApiV2');
            }
          }
        } catch (error) {
          console.error('Invalid token format:', error);
        }
      }
    }, 1000);
  },
  created() {
    const request = {
      pagination: {
        limit: 0,
        page: 1,
        column: 'id',
        ascending: false,
        query: '',
      },
    };
    this.$store.dispatch('jStoreLogin/getProfileAndRole', request);

    setTimeout(() => {
      this.showPreload = false;
    }, 3000);
    setTimeout(() => {
      this.showContent = true;
    }, 1000);
  },
  methods: {
    toggleSidebar(val) {
      this.sidebar = val;
    },
  },
};
</script>

<style scoped>
#sidebar-wrapper {
  z-index: 998 !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/jSettingWrapper.vue